/**
 * Leaving the app for ANOTHER origin — a Stripe checkout, GitHub's app-install page.
 *
 * In a browser tab this is a real top-level navigation (`location.assign`), exactly what the call
 * sites did inline before. A host that is not a browser tab — the VS Code "Docit" panel
 * (thinkinghub-vscode/webviews/docit-pages), where navigating the webview away would destroy the
 * app — swaps the implementation ONCE at boot with {@link setLeaveApp} so the URL opens in the
 * user's browser instead. One seam, not a per-call-site `if (inVsCode)`.
 */
export type LeaveApp = (url: string) => void;

const browserLeave: LeaveApp = (url) => {
  if (typeof window !== "undefined") {
    window.location.assign(url);
  }
};

let impl: LeaveApp = browserLeave;

/** Navigate away from the app to `url` (an off-origin page). */
export function leaveApp(url: string): void {
  impl(url);
}

/** Replace how the app leaves (a non-browser host). Pass `null` to restore the browser default. */
export function setLeaveApp(next: LeaveApp | null): void {
  impl = next ?? browserLeave;
}
